import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=26546bd2&scoped=true&"
import script from "./NewTag.vue?vue&type=script&lang=js&"
export * from "./NewTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26546bd2",
  null
  
)

export default component.exports